import { h } from 'preact';
import register from '@wcd/preact-custom-element';
import { useState } from 'preact/hooks';
import { Search } from '../../../types/web-components';

export const component: Search = ({ resourceid, pagetype }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const disabled = searchQuery === '';

  return (
    <div className="tds-form__group">
      <div className="tds-input-group">
        <input
          className="tds-control"
          type="text"
          value={searchQuery}
          placeholder="Search resources by keyword"
          onInput={(e) => setSearchQuery((e as any).target.value)}
        />
        <span className="tds-input-group__btn">
          <a
            className={`tds-btn tds-btn--md tds-btn--primary${disabled ? ' tds-btn--disabled' : ''}`}
            href={`/resources/search/?q=${encodeURIComponent(searchQuery)}`}
            data-mz            
            data-product-area="resources"            
            data-tracking-event="click"
            data-entity-id={resourceid}
            data-entity-type="resource"
            data-referrer= {document.referrer || window.location.href}
            {...(pagetype === "rdp"
                    ? {
                        "data-tracking-id": "rdp.search_bar",
                        "data-name": "rdp.search_bar"
                      }
                    : pagetype === "download" 
                    ? {
                        "data-tracking-id": "post_download_search",
                        "data-name": "rdp_download.search"
                      }
                    : {} )}
          >
            Search
          </a>
        </span>
      </div>
    </div>
  );
};

register(component, 'tes-search', [], { shadow: false });
